export default "__VITE_ASSET__DkPzFKbf__"